import { RouteObject } from 'react-router-dom'
import MeuAcessoPage from '@/pages/seguranca/MeuAcessoPage'

/**
 * Rotas do A16 (Onda 8) — páginas restantes do consultor.
 *
 * `/notificacoes` ficou registrada em `rotas/a14.tsx` (a NotificacoesPage do consultor
 * é do A16). Aqui só o que não tinha rota própria: a auto-visão de Usuários, que
 * substitui o `PorAba` Segurança/Perfil do A02 (`?aba=perfil` e o novo `?aba=seguranca`
 * continuam alcançáveis dentro da página).
 */
const rotasA16: RouteObject[] = [
  { path: 'usuarios/meu-acesso', element: <MeuAcessoPage /> },
]

export default rotasA16
